import { Component, Input, OnInit } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormGroup,
} from '@angular/forms';
import { ApplicationService } from '@core/services/application.service';
import { SessionService } from '@core/session.service';
import { environment } from '@env/environment';
import { NgxCaptchaModule } from 'ngx-captcha';

@Component({
  selector: 'app-google-recapcha',
  templateUrl: './google-recapcha.component.html',
  imports: [FormsModule, ReactiveFormsModule, NgxCaptchaModule],
})
export class GoogleRecapchaComponent implements OnInit {
  siteKey = environment.google_reCAPTCHA_siteKey;

  @Input() formInput: UntypedFormGroup;

  public useGlobalDomain = false;
  public reCAPTCHAlang = 'en';

  constructor(
    private readonly sessionService: SessionService,
    private readonly applicationService: ApplicationService
  ) {}

  ngOnInit(): void {
    this.reCAPTCHAlang = this.sessionService.getCurrentLanguage()?.code || 'en';
  }

  onSuccess(event: string): void {
    this.applicationService.verifyCaptChaSolution(event).subscribe();
  }
}
